import React from 'react';
import { Icon } from './Icon';

export const ChoiceStep = ({ choices, value, prefix, onChoose, compact = false }) => (
  <div className={`sim-choices ${compact ? 'sim-choices-compact' : ''}`} role="group" aria-labelledby="sim-step-title">
    {choices.map((choice) => <button key={choice.id} type="button" className={`sim-choice ${value === choice.id ? 'is-selected' : ''}`}
      data-testid={`${prefix}-${choice.id}`} aria-pressed={value === choice.id} onClick={() => onChoose(choice.id)}>
      <span className="sim-choice-icon"><Icon name={choice.icon} size={30} /></span>
      <span className="sim-choice-copy"><strong>{choice.label}</strong>{choice.description && <span>{choice.description}</span>}</span>
      <span className="sim-choice-arrow"><Icon name={value === choice.id ? 'check' : 'arrow'} size={19} /></span>
    </button>)}
  </div>
);